/**
 * Servicios
 */
//Importar el espacio de almacenamiento de base de datos firestore
import { pacientesStore, uhCollection, surgeryroomCollection, padronMedico } from '../firebase/config';


export const createCredential = async (credential) => {
    try {
        let hoy = new Date()
        await pacientesStore
        .collection(surgeryroomCollection)
        .add({
            copy_specialty_certificate : credential.copy_specialty_certificate,
            copy_professional_license : credential.copy_professional_license,
            name : credential.name,
            copy_subspecial_title : credential.copy_subspecial_title,
            curriculum_vitae : credential.curriculum_vitae,
            copy_professional_title:credential.copy_professional_title,
            status:credential.status,
            subspecialty:credential.subspecialty,
            copy_specialty_title:credential.copy_specialty_title,
            active : credential.active,
            specialty : credential.specialty,
            curp: credential.curp,
            specialty_array:credential.specialty_array,
            hospital : credential.hospital,
            url_copy_professional_title : credential.url_copy_professional_title,
            url_copy_professional_license : credential.url_copy_professional_license,
            url_copy_specialty_certificate : credential.url_copy_specialty_certificate,
            url_copy_specialty_title : credential.url_copy_specialty_title,
            url_copy_subspecial_title : credential.url_copy_subspecial_title,
            url_curriculum_vitae : credential.url_curriculum_vitae,
            identificador : credential.identificador,
            photo : credential.photo,
            url_photo : credential.url_photo,
            ine : credential.ine,
            url_ine : credential.url_ine,
            rfc : credential.rfc,
            url_rfc : credential.url_rfc,
            copy_of_office_operating_notice : credential.copy_of_office_operating_notice,
            url_copy_of_office_operating_notice : credential.url_copy_of_office_operating_notice,
            copy_state_registry_of_professions : credential.copy_state_registry_of_professions,
            url_copy_state_registry_of_professions : credential.url_copy_state_registry_of_professions,
            copy_subspecialty_professional_certificate : credential.copy_subspecialty_professional_certificate,
            url_copy_subspecialty_professional_certificate : credential.url_copy_subspecialty_professional_certificate,
            copy_specialty_board_certification : credential.copy_specialty_board_certification,
            url_copy_specialty_board_certification : credential.url_copy_specialty_board_certification,
            contancies : credential.contancies,
            cedula_array : credential.cedula_array,
            lastname : credential.lastname,
            basefotografia : credential.basefotografia,
            gender : credential.gender,
            baseine : "",
            baserfc : "",
            baseCv : "",
            base_copy_professional_title : "",
            base_copy_professional_license : "",
            base_copy_specialty_certificate : "",
            base_copy_specialty_title : "",
            base_copy_subspecialty_professional_certificate : "",
            base_copy_subspecial_title : "",
            base_copy_specialty_board_certification : "",
            base_copy_of_office_operating_notice : "",
            base_copy_state_registry_of_professions : "",
            base_contancies_one : "",
            copiaTituloProfesionalDay : credential.copiaTituloProfesionalDay,
            copiaTituloProfesionalExpiraDay : credential.copiaTituloProfesionalExpiraDay,
            tituloProfesionalExpedidoPor : credential.tituloProfesionalExpedidoPor,
            copiaCedulaProfesionalDay : credential.copiaCedulaProfesionalDay,
            copiaCedulaProfesionalExpiraDay : credential.copiaCedulaProfesionalExpiraDay,
            CedulaProfesionalExpedidoPor : credential.CedulaProfesionalExpedidoPor,
            copiaCedulaEspecialidadDay : credential.copiaCedulaEspecialidadDay,
            copiaCedulaEspecialidadExpiraDay : credential.copiaCedulaEspecialidadExpiraDay,
            CedulaEspecialidadExpedidoPor : credential.CedulaEspecialidadExpedidoPor,
            copiaTituloEspecialidadDay : credential.copiaTituloEspecialidadDay,
            copiaTituloEspecialidadExpiraDay : credential.copiaTituloEspecialidadExpiraDay,
            copiaTituloEspecialidadExpedidoPor : credential.copiaTituloEspecialidadExpedidoPor,
            copiaTituloSubEspecialidadDay : credential.copiaTituloSubEspecialidadDay,
            copiaTituloSubEspecialidadExpiraDay : credential.copiaTituloSubEspecialidadExpiraDay,
            copiaTituloSubEspecialidadExpedidoPor : credential.copiaTituloSubEspecialidadExpedidoPor,
            copiaTituloSubespecialidadDay : credential.copiaTituloSubespecialidadDay,
            copiaTituloSubespecialidadExpiraDay : credential.copiaTituloSubespecialidadExpiraDay,
            copiaTituloSubespecialidadExpedidoPor : credential.copiaTituloSubespecialidadExpedidoPor,
            certificacionConsejoEspecialidadDay : credential.certificacionConsejoEspecialidadDay,
            certificacionConsejoEspecialidadExpiraDay : credential.certificacionConsejoEspecialidadExpiraDay,
            certificacionConsejoEspecialidadExpedidoPor : credential.certificacionConsejoEspecialidadExpedidoPor,
            avisoFuncionamientoDay : credential.avisoFuncionamientoDay,
            avisoFuncionamientoExpiraDay : credential.avisoFuncionamientoExpiraDay,
            avisoFuncionamientoExpedidoPor : credential.avisoFuncionamientoExpedidoPor,
            registroEstatalProfesionalesDay : credential.registroEstatalProfesionalesDay,
            registroEstatalProfesionalesExpiraDay : credential.registroEstatalProfesionalesExpiraDay,
            registroEstatalProfesionalesExpedidoPor : credential.registroEstatalProfesionalesExpedidoPor,
            create : hoy.getFullYear()+"-"+(hoy.getMonth()+1)+"-"+hoy.getDate()
            
        })
        return "success"
    } catch (error) {
        return error
    }
}

export const createMedicalPadron = async (credential) => {
    try {
        await pacientesStore
        .collection(padronMedico)
        .add({
            copy_specialty_certificate : credential.copy_specialty_certificate,
            copy_professional_license : credential.copy_professional_license,
            name : credential.name,
            copy_subspecial_title : credential.copy_subspecial_title,
            curriculum_vitae : credential.curriculum_vitae,
            copy_professional_title:credential.copy_professional_title,
            status:credential.status,
            subspecialty:credential.subspecialty,
            copy_specialty_title:credential.copy_specialty_title,
            active : credential.active,
            specialty : credential.specialty,
            curp: credential.curp,
            specialty_array:credential.specialty_array,
            hospital : credential.hospital
        })
        return "success"
    } catch (error) {
        return error
    }
}

export const updateMedicalCredential = async (id,credential) => {
    try {
        await pacientesStore
        .collection(surgeryroomCollection)
        .doc(id)
        .update({
            copy_specialty_certificate : credential.copy_specialty_certificate,
            copy_professional_license : credential.copy_professional_license,
            name : credential.name,
            copy_subspecial_title : credential.copy_subspecial_title,
            curriculum_vitae : credential.curriculum_vitae,
            copy_professional_title:credential.copy_professional_title,
            status:credential.status,
            subspecialty:credential.subspecialty,
            copy_specialty_title:credential.copy_specialty_title,
            active : credential.active,
            specialty : credential.specialty,
            curp : credential.curp,
            hospital: credential.hospital,
            url_copy_professional_title : credential.url_copy_professional_title,
            url_copy_professional_license : credential.url_copy_professional_license,
            url_copy_specialty_certificate : credential.url_copy_specialty_certificate,
            url_copy_specialty_title : credential.url_copy_specialty_title,
            url_copy_subspecial_title : credential.url_copy_subspecial_title,
            url_curriculum_vitae:credential.url_curriculum_vitae,
            photo : credential.photo,
            url_photo : credential.url_photo,
            ine : credential.ine,
            url_ine : credential.url_ine,
            rfc : credential.rfc,
            url_rfc : credential.url_rfc,
            copy_of_office_operating_notice : credential.copy_of_office_operating_notice,
            url_copy_of_office_operating_notice : credential.url_copy_of_office_operating_notice,
            copy_state_registry_of_professions : credential.copy_state_registry_of_professions,
            url_copy_state_registry_of_professions : credential.url_copy_state_registry_of_professions,
            copy_subspecialty_professional_certificate : credential.copy_subspecialty_professional_certificate,
            url_copy_subspecialty_professional_certificate : credential.url_copy_subspecialty_professional_certificate,
            copy_specialty_board_certification : credential.copy_specialty_board_certification,
            url_copy_specialty_board_certification : credential.url_copy_specialty_board_certification,
            contancies : credential.contancies,
            gender : credential.gender,
            lastname : credential.lastname,
            specialty_array : credential.specialty_array,
            cedula_array : credential.cedula_array,
            basefotografia : credential.basefotografia,
            baseine : "",
            baserfc : "",
            baseCv : "",
            base_copy_professional_title : "",
            base_copy_professional_license : "",
            base_copy_specialty_certificate : "",
            base_copy_specialty_title : "",
            base_copy_subspecialty_professional_certificate : "",
            base_copy_subspecial_title : "",
            base_copy_specialty_board_certification : "",
            base_copy_of_office_operating_notice : "",
            base_copy_state_registry_of_professions : "",
            base_contancies_one : "",
            copiaTituloProfesionalDay : credential.copiaTituloProfesionalDay,
            copiaTituloProfesionalExpiraDay : credential.copiaTituloProfesionalExpiraDay,
            tituloProfesionalExpedidoPor : credential.tituloProfesionalExpedidoPor,
            copiaCedulaProfesionalDay : credential.copiaCedulaProfesionalDay,
            copiaCedulaProfesionalExpiraDay : credential.copiaCedulaProfesionalExpiraDay,
            CedulaProfesionalExpedidoPor : credential.CedulaProfesionalExpedidoPor,
            copiaCedulaEspecialidadDay : credential.copiaCedulaEspecialidadDay,
            copiaCedulaEspecialidadExpiraDay : credential.copiaCedulaEspecialidadExpiraDay,
            CedulaEspecialidadExpedidoPor : credential.CedulaEspecialidadExpedidoPor,
            copiaTituloEspecialidadDay : credential.copiaTituloEspecialidadDay,
            copiaTituloEspecialidadExpiraDay : credential.copiaTituloEspecialidadExpiraDay,
            copiaTituloEspecialidadExpedidoPor : credential.copiaTituloEspecialidadExpedidoPor,
            copiaTituloSubEspecialidadDay : credential.copiaTituloSubEspecialidadDay,
            copiaTituloSubEspecialidadExpiraDay : credential.copiaTituloSubEspecialidadExpiraDay,
            copiaTituloSubEspecialidadExpedidoPor : credential.copiaTituloSubEspecialidadExpedidoPor,
            copiaTituloSubespecialidadDay : credential.copiaTituloSubespecialidadDay,
            copiaTituloSubespecialidadExpiraDay : credential.copiaTituloSubespecialidadExpiraDay,
            copiaTituloSubespecialidadExpedidoPor : credential.copiaTituloSubespecialidadExpedidoPor,
            certificacionConsejoEspecialidadDay : credential.certificacionConsejoEspecialidadDay,
            certificacionConsejoEspecialidadExpiraDay : credential.certificacionConsejoEspecialidadExpiraDay,
            certificacionConsejoEspecialidadExpedidoPor : credential.certificacionConsejoEspecialidadExpedidoPor,
            avisoFuncionamientoDay : credential.avisoFuncionamientoDay,
            avisoFuncionamientoExpiraDay : credential.avisoFuncionamientoExpiraDay,
            avisoFuncionamientoExpedidoPor : credential.avisoFuncionamientoExpedidoPor,
            registroEstatalProfesionalesDay : credential.registroEstatalProfesionalesDay,
            registroEstatalProfesionalesExpiraDay : credential.registroEstatalProfesionalesExpiraDay,
            registroEstatalProfesionalesExpedidoPor : credential.registroEstatalProfesionalesExpedidoPor
        })
        return "success"
      } catch (error) {
        return error
      }
}

export const updateMedicalPadron = async (id, credential) => {
    try{
        await pacientesStore
        .collection(padronMedico)
        .doc(id)
        .update({
            copy_specialty_certificate : credential.copy_specialty_certificate,
            copy_professional_license : credential.copy_professional_license,
            name : credential.name,
            copy_subspecial_title : credential.copy_subspecial_title,
            curriculum_vitae : credential.curriculum_vitae,
            copy_professional_title:credential.copy_professional_title,
            status:credential.status,
            subspecialty:credential.subspecialty,
            copy_specialty_title:credential.copy_specialty_title,
            active : credential.active,
            specialty : credential.specialty,
            curp: credential.curp,
            specialty_array:credential.specialty_array,
            hospital : credential.hospital,
        })
        return "success"
    }
    catch (error){
        return error
    }
}

export const deleteMedicalCredential = async (id) => {
    try {
        await pacientesStore
        .collection(surgeryroomCollection)
        .doc(id)
        .delete()
        return "success"
      } catch (error) {
        return error
      }
}

export const updateUnidadHospitalariaLastNumber = async (id, number) => {
    try{
        await pacientesStore
        .collection(uhCollection)
        .doc(id)
        .update({
            num_asociado : number
        })
        return "success"
    }
    catch (error){
        console.log(error)
        return error
    }
}